import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { BankIdSessionResponse } from "../slices/bankid.slice";

// Base selector
const selectBankIdState = (state: RootState) => state.bankId;

// Loading states
export const selectBankIdLoadingStates = createSelector(
  [selectBankIdState],
  (bankId) => ({
    initiate: bankId.initiateBankIdLoading,
    verify: bankId.verifyBankIdSessionLoading,
  })
);

// Verification selectors
export const selectVerificationDetails = createSelector(
  [selectBankIdState],
  (bankId): BankIdSessionResponse | null => bankId.verificationDetails
);

export const selectVerificationSuccess = createSelector(
  [selectBankIdState],
  (bankId) => bankId.verificationSuccess
);

// Contact info selectors
export const selectBankIdContact = createSelector(
  [selectBankIdState],
  (bankId) => ({
    email: bankId.email,
    emailError: bankId.emailError,
    phone: bankId.phone,
    phoneError: bankId.phoneError,
  })
);

// Error selector
export const selectBankIdError = createSelector(
  [selectBankIdState],
  (bankId) => bankId.error
);

// Combined status
export const selectBankIdStatus = createSelector(
  [selectBankIdLoadingStates, selectBankIdError, selectVerificationSuccess],
  (loading, error, verificationSuccess) => ({
    isLoading: loading.initiate === "pending" || loading.verify === "pending",
    isVerified: !!verificationSuccess,
    hasError: !!error,
    isDone: loading.verify === "fulfilled" && !!verificationSuccess,
  })
);
